module.exports = __webpack_public_path__ + "static/media/L3.144352ae.jpg";